import { AssetType } from '@imcc/transport';
import { Type } from 'class-transformer';
import { OrderAssetParameters } from './order-asset-parameters';

export class CreateOrderAsset {
  assetType: AssetType;

  sourceAssetId: string;

  @Type(() => OrderAssetParameters)
  parameters: OrderAssetParameters;
}
